import axios from 'axios';

export const swal = require('sweetalert2');

export const HTTPFront = axios.create({
  baseURL: '/'
});

// La URL real de la API la resuelve el proxy /backend del server, que la lee de
// API_TENDIENDOPUENTES. Así el bundle no queda atado a un entorno.
export const HTTPAPI = axios.create({
  baseURL: '/backend'
});

export let showResponseErrorMessage = (responseError) => {
	let status =  responseError.status || 0;
	let message = responseError.message || '';

	if (status > 0) {
		let title = '';
		let text = '';
		let type = 'warning';
		
		switch (status) {
			case 400:
				title = 'Solicitud inválida';
				text = 'La solicitud enviada es incorrecta.';
				break;
			case 401:
				title = 'Acceso denegado';
				text = 'No posee permisos para acceder a este servicio.';
				break;
			// case 404:
			// 	title = 'Elemento no encontrado';
			// 	text = 'No se han encontrado registros para la solicitud enviada.';
			// 	break;
			case 405:
				title = 'Algo salió mal';
				text = 'Llamada a servicio no disponible.';
				break;
			case 500:
				title = 'Algo salió mal';
				text = 'Servicio temporalmente no disponible.';
				break;
			case 504:
				title = 'Algo salió mal';
				text = 'Servicio temporalmente no disponible.';
				break;
		}

		if (title || text) {
			swal({title: title, text: text, type: type });
		}
		
	}

};
